module.exports = __webpack_public_path__ + "img/p2-2-1.52e2deaf.png";